<template>
 <el-card class="box-card notices-card mb-35">
    <el-row>
      <el-col :span="24">
        <div class="card-header title">
          <span>{{ $t('noti_from_admin') }}</span>
          <hr>
        </div>
        <el-table :data="notices" :show-header="false">
          <el-table-column width="150" >
            <template #default="scope">
              <div class="create-time">
                <span>{{ formatDate(scope.row.created_at) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template #default="scope" >
              <span class="font-weight-700">{{ clipText(scope.row.title, 50) }}</span><br>
              <span v-html="clipText(scope.row.content_formated, 100)" class="content"></span>
            </template>
          </el-table-column>
        </el-table>
        <p class="text-right">
          <el-link type="primary" :href="url" class="show-all" :underline="false">{{ $t('show_all_noti') }}></el-link>
        </p>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      notices: { type: Object, required: true, default: {} },
      url: { type: String, required: true },
    },
    methods: {
      formatDate(dateTime) {
        return (dateTime) ? this.$dayjs(dateTime).format('YY.MM.DD') : '';
      },
      clipText(text, length) {
        let title = text || '...'
        if (text?.length > length) {
          title = (text || '').substring(0, length) + '...'
        }
        return title
      }
    },
  }
</script>
